import { IBuyParams, IBuyAndHoldParams, IPackage } from '../types';
import {
  buyAndHoldCustomPackage,
  buyCustomPackage,
  TBuyAndHoldCustomPackageParameters,
  TBuyCustomPackageParameters,
} from '../../../services';
import { TAppState } from '../../../types';
import { trackCancelClick, trackConfirmClick } from '../../../tracking';
import { selectBuyCustomPackageParams } from '../../../selectors';
import { selectAnalyticsLabel } from '../../../selectors/analytics';
import { selectBuyPackageModalAutoprolong } from '../../../selectors/buyPackageModal';

export class CustomPackage implements IPackage<TBuyCustomPackageParameters> {
  public async buy(params: IBuyParams<TBuyCustomPackageParameters>) {
    return buyCustomPackage(params);
  }

  public async buyWithHold(params: IBuyAndHoldParams<TBuyAndHoldCustomPackageParameters>) {
    return buyAndHoldCustomPackage(params);
  }

  public getParams(state: TAppState) {
    return selectBuyCustomPackageParams(state);
  }

  public trackCancel(state: TAppState): void {
    const label = selectAnalyticsLabel(state);

    trackCancelClick(label);
  }

  public trackConfirm(state: TAppState): void {
    const autoProlong = selectBuyPackageModalAutoprolong(state);
    const label = selectAnalyticsLabel(state);

    trackConfirmClick(autoProlong, label);
  }
}
